import { render, staticRenderFns } from "./notices.vue?vue&type=template&id=b971aa1c&scoped=true"
import script from "./notices.vue?vue&type=script&lang=js"
export * from "./notices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b971aa1c",
  null
  
)

export default component.exports